import { render } from "./dialogDetail.vue?vue&type=template&id=4e994cb2"
import script from "./dialogDetail.vue?vue&type=script&lang=js"
export * from "./dialogDetail.vue?vue&type=script&lang=js"

import "./dialogDetail.vue?vue&type=style&index=0&id=4e994cb2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__